const TOKEN_TYPE = {
    STANDARD: "Standard",
    ERC20: 'ERC20',
    ERC721: 'ERC721',
    ERC1155: 'ERC1155'
}

export default TOKEN_TYPE